module.exports = __webpack_public_path__ + "img/awardBack1.6484b8f2.png";